import React from 'react';
import { IOSSegmentedControl } from '../ios';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export type CalendarView = 'dayGridMonth' | 'timeGridWeek' | 'timeGridThreeDay' | 'timeGridDay' | 'listWeek';

interface CalendarViewSwitcherProps {
  currentView: CalendarView;
  onChange: (view: CalendarView) => void;
  className?: string;
}

/**
 * iOS风格的日历视图切换器组件
 */
export const CalendarViewSwitcher: React.FC<CalendarViewSwitcherProps> = ({
  currentView,
  onChange,
  className = '',
}) => {
  const { t } = useTranslation(['v3/calendar', 'v3/tasks']);

  const viewOptions = [
    { id: 'dayGridMonth', label: t('v3/calendar:viewModes.month', '月') },
    { id: 'timeGridWeek', label: t('v3/calendar:viewModes.week', '周') },
    { id: 'timeGridThreeDay', label: t('v3/calendar:viewModes.threeDay', '3日') },
    { id: 'timeGridDay', label: t('v3/calendar:viewModes.day', '日') },
    { id: 'listWeek', label: t('v3/tasks:viewMode.list', '列表') },
  ];

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="w-full max-w-xs"
      >
        <IOSSegmentedControl
          options={viewOptions}
          selectedId={currentView}
          onChange={(id) => onChange(id as CalendarView)}
          className="w-full"
        />
      </motion.div>
    </div>
  );
};
